export const PACK_IMAGE = "https://cdn.magicpatterns.com/uploads/pqkMPTH4Y64aZc2HprX9s2/pack-cns.png";

export const heroHighlights = ["1 libro principal", "5 bonos", "Foto y video", "Desde cero", "En español"];

export const CNS_INSTAGRAM_SCREENSHOT = "https://cdn.magicpatterns.com/uploads/m6eEJhrrqUVgJxnmoQgqVT/tempImagetG6yZo.png";
export const MARCIO_PHOTO =
  "https://cdn.magicpatterns.com/uploads/8CC5o5Vd3nQXS7Rpay4sqT/Retrato_con_guia_de_fotografia_para_iPhone.png";

export const stats = [
  { value: "185K", label: "Seguidores de CNS" },
  { value: "1 + 5", label: "Libro + bonos" },
  { value: "6", label: "Partes en el libro" },
  { value: "Digital", label: "Teléfono, tablet o compu" },
];

export const cnsFacts = [
  { value: "185K", label: "seguidores en Instagram" },
  { value: "+880", label: "publicaciones con consejos" },
  { value: "Saavedra", label: "local en CABA" },
];

export const problems = [
  {
    title: "En persona se ve mucho mejor",
    body: "La luz, el fondo o el encuadre hacen que se pierdan los detalles que querés destacar.",
  },
  {
    title: "Tenés opciones que no entendés",
    body: "Probás modos y ajustes sin saber cuál te sirve en esa escena.",
  },
  {
    title: "Publicás la toma que menos te disgusta",
    body: "Sacás diez fotos parecidas y ninguna te convence del todo.",
  },
  {
    title: "Grabar te frena",
    body: "Querés mostrar un producto, explicar tu servicio o aparecer en cámara, pero no sabés por dónde empezar.",
  },
];

export const audiences = ["Gastronomía", "Ropa y accesorios", "Uñas y estética", "Artesanías", "Tecnología", "Servicios"];

export const practicePieces = [
  { title: "Foto principal", body: "Una imagen clara que presente lo que vendés." },
  { title: "Foto de detalle", body: "Textura y terminaciones que merecen verse." },
  { title: "Foto en uso", body: "Que se entienda el tamaño y para qué sirve." },
  { title: "Video de demostración", body: "Mostrá cómo funciona, paso a paso." },
  { title: "Video del proceso", body: "Hacé visible el trabajo detrás del resultado." },
];

export const chapters = [
  { number: "01", area: "Cámara", title: "Sabé qué tocar", body: "Enfoque, exposición, modos, cámaras y zoom. Cuándo usar cada herramienta de tu equipo." },
  { number: "02", area: "Luz y escena", title: "Prepará una toma mejor", body: "Fondos, sombras, reflejos, posiciones y luz de ventana con recursos accesibles." },
  { number: "03", area: "Fotografía", title: "Hacé lucir lo que vendés", body: "Foto principal, detalles, escala y uso. Ejemplos de comida, ropa, accesorios y servicios." },
  { number: "04", area: "Video", title: "Grabá con intención", body: "Encuadres, estabilidad, movimientos, foco y audio para demostraciones y procesos." },
  { number: "05", area: "Edición", title: "Dale el toque final", body: "Recorte, luz y color desde Fotos, conservando la apariencia real del producto." },
  { number: "06", area: "Práctica", title: "Aplicalo a tu negocio", body: "Ejercicios, checklist y soluciones a problemas frecuentes para revisar tus tomas." },
];

export const bonuses: { number: string; title: string; body: string; cover: string | null }[] = [
  {
    number: "01",
    cover: "https://cdn.magicpatterns.com/uploads/c5RcLkrexzC1BJY1rKPQ3d/mockup-tu-miniestudio-en-casa.png",
    title: "Tu Miniestudio en Casa",
    body: "Armá un espacio con recursos accesibles: esquemas de iluminación, fondos y posiciones del iPhone para una mesa o un rincón de tu casa.",
  },
  {
    number: "02",
    cover: null,
    title: "30 Ideas para Mostrar lo que Vendés",
    body: "Ideas de fotos y videos para presentar productos, mostrar detalles y responder dudas. Qué mostrar y cómo adaptarlo.",
  },
  {
    number: "03",
    cover: "https://cdn.magicpatterns.com/uploads/fmndCh1LcvcfkYQmXrXS1y/mockup-frente-a-camara-mostra-tu-negocio-con-confianza.png",
    title: "Frente a Cámara",
    body: "Ejercicios y estructuras breves para presentarte, explicar lo que ofrecés y responder preguntas con naturalidad.",
  },
  {
    number: "04",
    cover: "https://cdn.magicpatterns.com/uploads/6vWm5ZppcfKCiPKTwVmv9H/mockup-tu-catalogo-con-iphone.png",
    title: "Tu Catálogo con iPhone",
    body: "Reuní tus fotos en un catálogo claro para WhatsApp, redes o tu tienda, con plantillas para organizar los datos.",
  },
  {
    number: "05",
    cover: "https://cdn.magicpatterns.com/uploads/1V6S4Fmo6miAjhtua6H8UC/mockup-de-la-foto-a-la-consulta.png",
    title: "De la Foto a la Consulta",
    body: "Textos que acompañan tus imágenes: títulos, descripciones y llamados a la acción adaptables.",
  },
];

export const packItems = [
  "Libro principal: Tu iPhone, Tu Estudio",
  "Bono 1 · Tu Miniestudio en Casa",
  "Bono 2 · 30 Ideas para Mostrar lo que Vendés",
  "Bono 3 · Frente a Cámara",
  "Bono 4 · Tu Catálogo con iPhone",
  "Bono 5 · De la Foto a la Consulta",
];

export const faqs = [
  { q: "¿Necesito saber fotografía?", a: "No. El recorrido está pensado para empezar desde cero, con explicaciones claras y prácticas aplicadas a tu emprendimiento." },
  { q: "¿Necesito un iPhone Pro o el modelo más nuevo?", a: "No. Las bases de luz, encuadre y preparación sirven con tu equipo. Algunas herramientas dependen del modelo y de la versión de iOS; la guía distingue esas diferencias." },
  { q: "¿Tengo que comprar luces o accesorios?", a: "Podés empezar con luz disponible, un fondo sencillo y un apoyo estable. Los accesorios se presentan como mejoras opcionales." },
  { q: "¿Sirve si vendo servicios?", a: "Sí. Incluye cómo aparecer en cámara, registrar procesos y mostrar tu trabajo, además de ejemplos de productos físicos." },
  { q: "¿Incluye fotos y videos?", a: "Sí. El libro aborda fotografía, grabación, preparación de escena y edición básica, con ejercicios para aplicar lo aprendido." },
  { q: "¿En qué formato está?", a: "Es material digital en español para leer y consultar desde tu teléfono, tablet o computadora. No es un curso en video." },
  { q: "¿Me garantiza conseguir clientes?", a: "Te enseña a producir contenido que muestre mejor lo que ofrecés. Las consultas y ventas también dependen de tu oferta, precio, audiencia y difusión." },
  { q: "¿Es lo mismo que Diccionario Apple?", a: "No. Diccionario Apple se enfoca en el uso general del iPhone. Tu iPhone, Tu Estudio profundiza en la cámara y en crear fotos y videos para emprendimientos." },
];

export const withoutGuide = [
  "Probás modos al azar y publicás la toma que menos te disgusta.",
  "La luz y el fondo esconden los detalles de lo que vendés.",
  "Grabar un video o aparecer en cámara te frena.",
  "Tus fotos quedan sueltas, sin un catálogo ordenado.",
];

export const withGuide = [
  "Sabés qué ajustar: enfoque, exposición, distancia y encuadre.",
  "Preparás una escena con una ventana y un fondo sencillo.",
  "Grabás demostraciones y procesos con intención.",
  "Ordenás tus fotos en un catálogo y las acompañás con textos claros.",
];
